module.exports = __webpack_public_path__ + "static/media/exit.b7da685a.svg";